import React, { useState,  useEffect, useRef} from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress,  
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';

import _ from 'lodash';


import withAlert from "../../hoc/withAlert";
import Meeting from './components/Meeting';
// import DetailPanel from './components/DetailPanel';

import {
  getMeetingsSelector
} from '../../store/meetings';

import {
  initPage,
  getRequestErrorsByPageSelector,
  getPageReadyByPageSelector
} from '../../store/api';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  displayNone: {display:'none'}
}));




const ReportMeal = (props) => {
  const classes = useStyles();
  // Заберем из HOC нужные методы для показа алерта
  const {setSnackMessage, setSnackType, setOpenSnack} = props
  const meetingsData = useSelector(getMeetingsSelector);
  const dispatch = useDispatch();

  const pageReady = useSelector(
    getPageReadyByPageSelector(props.location.pathname)
  );

  useEffect(() => {
    const getData = async () => {
        // await dispatch(loadMeal());
        await initPage(props.location.pathname, dispatch);

    };
    getData();
  }, [dispatch]);

  // useEffect(() => {
  //   if(mealData){
  //     setState({columns: tableColumns, data: _.cloneDeep(mealData)})
  //   }
  // }, [mealData]);

// console.log('meetingsData',meetingsData);



  return (
    <React.Fragment>
    {pageReady === false && (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <CircularProgress disableShrink size={56} />
      </div>
    )}

    {pageReady !== false && meetingsData.length > 0  && (

    <div className={classes.root}>

      <div className={classes.content}>

        <Card>
          <CardHeader
          title="Отчет по заказам"
          />
          <Divider />
          <CardContent>
          {
          _.orderBy(meetingsData, ['name'], ['asc']).map((m, index) => (
            <Meeting
              key={index}
              meeting={m}
            />
          )
          )}


          </CardContent>
        </Card>
      </div>
    </div>
    )}
    </React.Fragment>
  );
};

export default withAlert(ReportMeal);
